import { render } from "./AdministratieView.vue?vue&type=template&id=6c1e337c"
import script from "./AdministratieView.vue?vue&type=script&lang=js"
export * from "./AdministratieView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__